document.addEventListener("DOMContentLoaded", () => {
    fixAriaLabels(rtTranslations.rad.calendar);
});

function fixAriaLabels(calendar) {
    if (typeof $telerik == 'undefined' || typeof $telerik.$ !== 'function') return;

    var nextButton = $telerik.$(".rcNext");
    nextButton.attr("aria-label", calendar.nextMonth);
    nextButton.attr("title", calendar.nextMonth);

    var prevButton = $telerik.$(".rcPrev");
    prevButton.attr("aria-label", calendar.prevMonth);
    prevButton.attr("title", calendar.prevMonth);

    var nextFastButton = $telerik.$(".rcFastNext");
    nextFastButton.attr("aria-label", calendar.nextFast);
    nextFastButton.attr("title", calendar.nextFast);

    var prevFastButton = $telerik.$(".rcFastPrev");
    prevFastButton.attr("aria-label", calendar.prevFast);
    prevFastButton.attr("title", calendar.prevFast);
}